import React from "react"
import { graphql } from "gatsby"

import { StoryWithQuickLinks } from "@hurleymc/components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from "../components/link"
import PageBuilder, { getPropHtmlContent } from "../components/page-builder"

const Home = ({ data }) => {
  const { craft } = data
  const { entries } = craft
  const entry = entries[0]
  const image =
    entry.images && entry.images.length > 0 && entry.images[0].lg
      ? entry.images[0].lg
      : null
  // ! Have to map fields for the components
  entry.quickLinks = entry.quickLinks.map((ql) => ({
    ...ql,
    summary: getPropHtmlContent(ql.summary),
  }))
  return (
    <Layout>
      <SEO title={"Home"} image={image} />
      <StoryWithQuickLinks
        components={{ Link }}
        image={entry.images}
        linkText={entry.linkText}
        quickLinks={entry.quickLinks}
        storyStatement={entry.storyStatement}
        storyStatementColor={entry.storyStatementColor}
        to={entry.to}
      />
      {entry && entry.pageBuilder && (
        <PageBuilder
          pageBuilder={entry.pageBuilder}
          location={{ pathname: entry.uri }}
        />
      )}
    </Layout>
  )
}

export const query = graphql`
  query Home($id: [Craft_QueryArgument]!) {
    craft {
      entries(site: "hurleyGme", id: $id) {
        __typename
        title
        uri
        ... on Craft_gmeHome_gmeHome_Entry {
          images {
            ... on Craft_AssetInterface {
              title
              url
              lg: url(transform: "splashLg", immediately: true)
              xl: url(transform: "splashXl", immediately: true)
            }
          }
          storyStatement
          storyStatementColor
          linkText
          to {
            ...Link
          }
          quickLinks {
            ... on Craft_quickLink_quickLink_Entry {
              icon
              id
              header
              summary
              to {
                ...Link
              }
            }
          }
          pageBuilder {
            ...PageBuilder
          }
        }
      }
    }
  }
`

export default Home
